import styles from "./styles.module.css"

export default function InputTextArea({value,setValue,name}) {
    return (
        <div className={styles.InputTextArea}>
            <label htmlFor="synopsis">{name}</label>
            <textarea value={value} onChange={(event) => { setValue(event.target.value) }} name="synopsis" cols="30" rows="10"></textarea>
        </div>
    );
}